import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { KYMW7000Component } from './kymw7000.component';
import { CheckFeatureSelectionService } from './api-services/check-feature-selection.service';
import { ConfirmFeatureInfoByPlannerService } from './api-services/confirm-feature-info-by-planner.service';
import { DownloadFeatureGoodsService } from './api-services/download-feature-goods.service';
import { GetCatalogIdService } from './api-services/get-catalog-id.service';
import { GetFeatureListService } from './api-services/get-feature-list.service';
import { GetFeatureThemaService } from './api-services/get-feature-thema.service';
import { GetGoodsBaseService } from './api-services/get-goods-base.service';
import { GetGoodsCoopService } from './api-services/get-goods-coop.service';
import { GetMediumListByOrderService } from './api-services/get-medium-list-by-order.service';
import { GetSelectionGoodsListService } from './api-services/get-selection-goods-list.service';
import { GetSelectionRequestListService } from './api-services/get-selection-request-list.service';
import { GetTargetListByFeatureGoodsSelectionService } from './api-services/get-target-list-by-feature-goods-selection.service';
import { SaveFeatureInfoByPlannerService } from './api-services/save-feature-info-by-planner.service';
import { GetGoodsPlanNumService } from './api-services/get-goods-plan-num.service';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { KYMW7002Module } from '../kymw7002/kymw7002.module';
import { KYMW7003Module } from '../kymw7003/kymw7003.module';

/**
 * タグ管理画面 モジュール設定クラス
 *
 * @export KYMW7000Module
 * @class KYMW70000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
    WjGridModule,
    WjGridFilterModule,
    KYMW7002Module,
    KYMW7003Module,
  ],
  declarations: [KYMW7000Component],
  providers: [
    CheckFeatureSelectionService,
    ConfirmFeatureInfoByPlannerService,
    DownloadFeatureGoodsService,
    GetCatalogIdService,
    GetFeatureListService,
    GetFeatureThemaService,
    GetGoodsBaseService,
    GetGoodsCoopService,
    GetGoodsPlanNumService,
    GetMediumListByOrderService,
    GetSelectionGoodsListService,
    GetSelectionRequestListService,
    GetTargetListByFeatureGoodsSelectionService,
    SaveFeatureInfoByPlannerService,
    GetCodeListService,
  ],
})
export class KYMW7000Module {}
